import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbProps {
  customPath?: { label: string; href?: string }[];
}

export default function Breadcrumb({ customPath }: BreadcrumbProps) {
  const location = useLocation();

  const getDefaultBreadcrumbs = () => {
    const paths = location.pathname.split('/').filter(Boolean);
    const crumbs = [{ label: '首页', href: '/' }];

    if (paths[0] === 'category' && paths[1]) {
      crumbs.push({ label: '分类浏览', href: '/category/all' });
      const categoryMap: Record<string, string> = {
        all: '全部',
        entertainment: '娱乐搞笑',
        music: '音乐舞蹈',
        food: '美食烹饪',
        travel: '旅行户外',
        tech: '科技数码',
        sports: '体育运动',
        lifestyle: '生活日常',
        knowledge: '知识科普',
        game: '游戏电竞',
      };
      crumbs.push({ label: categoryMap[paths[1]] || paths[1] });
    } else if (paths[0] === 'article') {
      crumbs.push({ label: '视频详情' });
    } else if (paths[0] === 'about') {
      crumbs.push({ label: '关于我们' });
    }

    return crumbs;
  };

  const breadcrumbs = customPath || getDefaultBreadcrumbs();

  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {breadcrumbs.map((crumb, index) => {
          const isLast = index === breadcrumbs.length - 1;
          return (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-300 text-sm"></i>
              )}
              {crumb.href && !isLast ? (
                <Link
                  to={crumb.href}
                  className="text-foreground-400 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  {crumb.label}
                </Link>
              ) : (
                <span className={`whitespace-nowrap ${isLast ? 'text-foreground-700 font-medium' : 'text-foreground-400'}`}>
                  {crumb.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}